<template>
  <div
    class="my-footer"
    v-if="
      Object.keys(defaultProxyDetails) &&
      Object.keys(defaultProxyDetails).length >= 0
    "
  >
    <div class="footer-left">
      <div class="follow" @click="handleLike">
        <img
          v-if="!defaultProxyDetails.isLike"
          src="../../../assets/images/article/icon-case.png"
          alt=""
          class="img"
        />
        <img
          v-else
          src="../../../assets/images/article/icon-case-active.png"
          alt=""
          class="img"
        />
        <span class="num" v-if="defaultProxyDetails && defaultProxyDetails.baseProxy">{{
          defaultProxyDetails.baseProxy.likeNum
        }}</span>
        <span class="num" v-else-if="defaultProxyDetails">{{
          defaultProxyDetails.likeNum
        }}</span>
      </div>
      <div class="follow" @click="handleCollect">
        <img
          v-if="!defaultProxyDetails.isCollect"
          src="../../../assets/images/article/icon-follow.png"
          alt=""
          class="img"
        />
        <img
          v-else
          src="../../../assets/images/article/icon-follow-active.png"
          alt=""
          class="img"
        />
        <span class="num" v-if="defaultProxyDetails && defaultProxyDetails.baseProxy">{{
          defaultProxyDetails.baseProxy.collectNum
        }}</span>
        <span class="num" v-else-if="defaultProxyDetails">{{
          defaultProxyDetails.collectNum
        }}</span>
      </div>
      <div class="follow" @click="handleTranspond">
        <img
          src="../../../assets/images/article/icon-transpond.png"
          alt=""
          class="img"
        />
      </div>
    </div>
    <div class="footer-right">
      <template
        v-if="defaultProxyDetails.liveState || defaultProxyDetails.baseProxy"
      >
        <div
          class="footer-btn"
          v-if="
            defaultProxyDetails.liveState === '进行中' ||
            defaultProxyDetails.liveState === '已结束'
          "
          @click="handleClickLive"
        >
          {{ `${defaultProxyDetails.liveState === '进行中' ? '进入' : defaultProxyDetails.liveState}` }}
        </div>
        <div
          class="footer-btn"
          v-else-if="
            defaultProxyDetails.baseProxy &&
            Object.keys(defaultProxyDetails.baseProxy).length >= 0
          "
          @click="handleClickMake"
        >
          {{ `${defaultProxyDetails.ismake}` === "1" ? "已预约" : "预约" }}
        </div>
      </template>
      <template v-else-if="defaultProxyDetails.nextId && routerPath.indexOf('xwzy') < 0">
        <div
          class="footer-btn"
          @click="handleNext"
          v-if="defaultProxyDetails.nextId != '0'"
        >
          下一篇
        </div>
      </template>
    </div>
    <transpond
      ref="transpond"
      @handlecanel="handlecanel"
      v-if="isTranspond"
    ></transpond>
  </div>
</template>

<script>
import { liveMake } from '@/api/api'
import transpond from './transpond.vue'
export default {
  name: 'articleFooter',
  data() {
    return {
      isTranspond: false,
    }
  },
  components: {
    transpond,
  },
  props: {
    defaultProxyDetails: {
      type: Object,
      required: true,
    },
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    routerPath() {
      return this.$route.path
    }
  },
  mounted() {
  },
  methods: {
    handleClickMake() {
      let params = {
        userId: this.userInfo.id,
        liveId: this.defaultProxyDetails.id,
        type: `${this.defaultProxyDetails.ismake}` === '0' ? 1 : 0,
      }
      liveMake(params).then((res) => {
        if (res && res.code === 111) {
          return
        }
        this.$toast(
          `${this.defaultProxyDetails.ismake}` === '0'
            ? '预约成功'
            : '取消预约成功'
        )
        this.defaultProxyDetails.ismake =
          `${this.defaultProxyDetails.ismake}` === '0' ? 1 : 0
      })
    },
    handleClickLive() {
      this.$emit('handleClickLive')
    },
    handlecanel() {
      this.isTranspond = !this.isTranspond
    },
    handleNext() {
      this.$emit('handleNext', this.defaultProxyDetails.nextId)
    },
    // 点赞
    handleLike() {
      this.$emit('handleLike')
    },
    // 收藏
    handleCollect() {
      this.$emit('handleCollect')
    },
    // 转发
    handleTranspond() {
      this.isTranspond = true
    },
  },
}
</script>

<style lang="less" scoped>
.my-footer {
  display: flex;
  align-items: center;
  // justify-content: ;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  height: 70px;
  padding: 12px 12px 15px;
  box-sizing: border-box;
  width: 100%;
  background: #fff;

  .footer-left {
    flex: 1;
    display: flex;
    align-items: center;

    .follow {
      flex: 1;
      display: flex;
      align-items: center;

      .img {
        width: 22px;
        height: 22px;
        margin-right: 3px;
      }

      .num {
        font-weight: 500;
        font-size: 14px;
        color: #323232;
        line-height: 20px;
      }
    }
  }

  .footer-right {
    width: 40%;
    display: flex;
    flex-direction: row-reverse;

    .footer-btn {
      width: 110px;
      height: 42px;
      background: #EB1700;
      box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
      border-radius: 22px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/article/components/footerCom.vue